import { environment } from 'src/environments/environment';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class VisibilityGroupService {
    constructor(private http: HttpClient) {}

    getUserVisibilityGroups() {
        return this.http.get<any>( `${environment.appOrgUrl}VisibilityManagement`);
    }

    addVisibilityGroup(groupData){
        return this.http.post<any>( `${environment.appOrgUrl}VisibilityManagement`, groupData);
    }

    updateVisibilityGroup(groupData){
        return this.http.put<any>( `${environment.appOrgUrl}VisibilityManagement`, groupData);
    }

    addUserGroup(userGroupData){
        return this.http.post<any>( `${environment.appOrgUrl}VisibilityManagement/VisibilityGroupConfig/UserGroup`, userGroupData);
    }

    addModuleRecord(moduleData){
        return this.http.post<any>( `${environment.appOrgUrl}VisibilityManagement/VisibilityGroupConfig/ObjectGroup`, moduleData);
    }

    deleteVisibityGroup(groupId: number){
        return this.http.delete<any>(`${environment.appOrgUrl}VisibilityManagement/${groupId}`);
    }

    makeDefaultVisibilityGroup(groupId: number){
        return this.http.get<any>( `${environment.appOrgUrl}VisibilityManagement/VisibilityGroupConfig/Default/${groupId}`);
    }

    updateProfile(profileData){
        return this.http.put<any>( `${environment.appOrgUrl}UserProfile`, profileData);
    }

    getAssignedUserGroup(visibilityGroupId: number){
        return this.http.get<any>( `${environment.appOrgUrl}VisibilityManagement/UserGroup/${visibilityGroupId}`);
    }

    getAssignedJobTypeUsers(visibilityGroupId: number){
        return this.http.get<any>( `${environment.appOrgUrl}VisibilityManagement/JobTypeUsers/${visibilityGroupId}`);
    }

    getAssignedModuleRecord(moduleId: number, visibilityGroupId: number, requestPayload){
        return this.http.post<any>( `${environment.appOrgUrl}VisibilityManagement/ObjectDetail/${moduleId}/${visibilityGroupId}`, requestPayload);
    }

    getAssignedModuleRecordMinified(moduleId: number, visibilityGroupId: number){
        return this.http.get<any>( `${environment.appOrgUrl}VisibilityManagement/${moduleId}/${visibilityGroupId}`);
    }

}
